<section fxLayout="column" fxFlexAlign="stretch"> 
    <table>
        <tr>
           <!-- <td style="vertical-align: top;width: 30%;">
               <img src="../../assets/image-shell.png" width="100%" />
           </td>  -->
           <td style="vertical-align: top;padding-left: 12px;">
               <div class="row">
                   
                   <h2>ΠΛΗΡΟΦΟΡΙΕΣ ΣΥΜΜΕΤΟΧΗΣ</h2>
                   <br/>
                   <p>Η εγγραφή στο Συνέδριο για ΕΥ (Επαγγελματίες Υγείας) έχει ως εξής:</p>

                    <table>
                        <tr style="background-color: #013971;;">
                            <td style="width:70%;padding:20px;color:white;font-size: larger;border-bottom: #FBC932 5px solid">ΚΑΤΗΓΟΡΙΑ</td>
                            <td style="width:30%;padding:20px;color:white;font-size: larger;border-bottom: #FBC932 5px solid">ΚΟΣΤΟΣ</td>
                        </tr>
                        <tr>
                            <td style="width:70%;padding:20px;color:black;font-size: larger;border-bottom: #FBC932 5px solid">ΕΙΔΙΚΟΙ ΟΦΘΑΛΜΙΑΤΡΟΙ</td>
                            <td style="width:30%;padding:20px;color:black;font-size: larger;border-bottom: #FBC932 5px solid">150 €</td>
                        </tr>
                        <tr>
                            <td style="width:70%;padding:20px;color:black;font-size: larger;border-bottom: #FBC932 5px solid">ΕΙΔΙΚΕΥΟΜΕΝΟΙ</td>
                            <td style="width:30%;padding:20px;color:black;font-size: larger;border-bottom: #FBC932 5px solid">70 €</td>
                        </tr>
                        <tr>
                            <td style="width:70%;padding:20px;color:black;font-size: larger;border-bottom: #FBC932 5px solid">
                                <div>ΛΟΙΠΕΣ ΚΑΤΗΓΟΡΙΕΣ*</div>
                                <div>*ΠΡΟ-ΠΤΥΧΙΑΚΟΙ ΦΟΙΤΗΤΕΣ - ΝΟΣΗΛΕΥΤΕΣ - ΟΠΤΟΜΕΤΡΕΣ</div>
                            </td>
                            <td style="width:30%;padding:20px;color:black;font-size: larger;border-bottom: #FBC932 5px solid">ΔΩΡΕΑΝ</td>
                        </tr>
                    </table>
                    <br/>
                    <p>Η συμμετοχή στο Συνέδριο, περιλαμβάνει δυνατότητα παρακολούθησης του επιστημονικού προγράμματος, παραλαβή συνεδριακού υλικού, είσοδο στην έκθεση, συμμετοχή στις κοινωνικές εκδηλώσεις του Συνεδρίου και παραλαβή του ηλεκτρονικού πιστοποιητικού συμμετοχής, βάσει των ωρών παρακολούθησης.</p>
                    <p>Για νοσηλευτές/φοιτητές/οπτομέτρες, η συμμετοχή στο Συνέδριο είναι δωρεάν και περιλαμβάνει δυνατότητα παρακολούθησης του επιστημονικού προγράμματος, είσοδο στην έκθεση, και απλή βεβαίωση συμμετοχής. Η ιδιότητα τους ωστόσο, θα πρέπει να βεβαιώνεται από επίσημο φορέα που μπορεί να πιστοποιήσει την ιδιότητα τους (πχ επιστολή από τον διευθυντή της κλινικής για τους νοσηλευτές)</p>
                    <p>Καθ’ όλη τη διάρκεια του Συνεδρίου θα υπάρχει μετάφραση των ομιλιών, καθώς και σύστημα ηλεκτρονικής καταμέτρησης των ωρών παρακολούθησης του προγράμματος. Το Συνέδριο μοριοδοτείται με 18 μόρια συνεχιζόμενης εκπαίδευσης, και η παραλαβή του πιστοποιητικού προϋποθέτει τη συμπλήρωση -ηλεκτρονικά- του ανώνυμου εντύπου αξιολόγησης και την παρακολούθηση του 60% των ωρών του επιστημονικού προγράμματος, κατ’ ελάχιστον.</p>
                    <br/><br/><br/>

                    <h2>ΑΚΥΡΩΣΕΙΣ</h2>
                    <p>Το δικαίωμα συμμετοχής στο συνέδριο δεν επιστρέφεται.</p>
                    <br/>

                    <h2>ΤΡΟΠΟΙ ΠΛΗΡΩΜΗΣ</h2>

                    <p><b>Έως το συνέδριο:</b></p>
                    <div>Κατάθεση ποσού στην Εθνική Τράπεζα, σε διαταγή:</div>
                    <p><b>ΕΛΛΗΝΙΚΗ ΕΤΑΙΡΕΙΑ ΓΛΑΥΚΩΜΑΤΟΣ</b></p>
                    <br>
                    <div><b>Αριθμός Λογαριασμού 169/629649-18 </b></div>
                    <div><b>IBAN No GR8701101690000016962964918</b></div>
                    <div>αναφέροντας ονοματεπώνυμο και ιδιότητα συνέδρου (ειδικευμένος/ειδικευόμενος)</div>
                    <br/>
                    <p><b>Κατά τη διάρκεια του συνεδρίου:</b></p>
                    <p>Πληρωμή στη γραμματεία των εγγραφών</p>

                    <br/>

                    <h2>ΓΡΑΜΜΑΤΕΙΑ ΣΥΝΕΔΡΙΟΥ</h2>

                    <p>Η Γραμματεία θα λειτουργεί καθ’ όλη τη διάρκεια διεξαγωγής του συνεδρίου, τις ακόλουθες ώρες:</p>
                    <p><b>ΠΕΜΠΤΗ 30/03/2023: 13.00 – 19.30</b></p>
                    <p><b>ΠΑΡΑΣΚΕΥΗ 31/03/2023: 09.00 - 19.30</b></p>
                    <p><b>ΣΑΒΒΑΤΟ 01/04/2023: 09.00 - 19.00</b></p>

                    <br/>

                    <h2>ΣΥΝΕΔΡΙΑΚΕΣ ΑΙΘΟΥΣΕΣ & ΧΩΡΟΣ ΕΚΘΕΣΗΣ </h2>
                    <p><b>30 Μαρτίου 2023</b></p>
                    <p>Το συνέδριο θα πραγματοποιηθεί, στον ημιόροφο του Ξενοδοχείου KING GEORGE.</p>

                    <p><b>31 Μαρτίου - 01 Απριλίου 2023 </b></p>
                    <p>Το συνέδριο θα πραγματοποιηθεί στις αίθουσες του Ξενοδοχείου ΜΕΓΑΛΗ ΒΡΕΤΑΝΙΑ.</p>
                    <p>Ο χώρος έκθεσης των εταιρειών του κλάδου, θα λειτουργήσει σε παράπλευρες αίθουσες της συνεδριακής, στο Ξενοδοχείο ΜΕΓΑΛΗ ΒΡΕΤΑΝΙΑ.</p>

                    <br/>

                    <h2>ΔΙΑΜΟΝΗ ΣΥΝΕΔΡΩΝ - ΠΛΗΡΟΦΟΡΙΕΣ ΚΡΑΤΗΣΗΣ ΔΩΜΑΤΙΩΝ </h2>
                    <p>Επισημαίνεται ότι κρατήσεις δωματίων για τους συνέδρους στο Ξενοδοχείο ΜΕΓΑΛΗ ΒΡΕΤΑΝΙΑ δεν γίνονται, καθώς χρησιμοποιείται μόνο ως χώρος διεξαγωγής του συνεδρίου. Οι ενδιαφερόμενες εταιρείες θα πρέπει να μεριμνήσουν σχετικά, σε άλλα ξενοδοχεία, λαμβάνοντας υπόψη ότι το κόστος φιλοξενίας (διαμονή και διατροφή) των επαγγελματιών υγείας δεν μπορεί να υπερβαίνει τα ποσά που ορίζουν οι επικαιροποιημένες εγκύκλιοι ΕΟΦ και ΣΦΕΕ.</p>
                    <!-- <div><img src="..\..\assets\images\terzidou.jpg" /></div> -->
               </div>
           </td>
        </tr>
    </table>
    </section>